<template>
    <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <!-- <button class="button-back terciario icon">
        <svg style="width:33px;" viewBox="0 0 24 24">
          <path fill="currentColor" d="M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z" />
        </svg>
        </button> -->
      </div>
	  <!--<div class="col-12 copywrite">Copyright © 2020 by Nuevo Capital S.A. All Rights Reserved.</div>-->
    </div>
    </div>
</template>
<script>
export default {
	name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue